module.exports = __webpack_public_path__ + "75086cae3c1e76dad0be10386576beb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile8.png
// module id = 1891
// module chunks = 0